import Api from '@/services/api'

export default {
  images_upload_handler: function (blobInfo, success, failure, progress) {
    var formData
    formData = new FormData()
    formData.append('image', blobInfo.blob(), blobInfo.filename())

    Api.post(`admin/editor-image`, formData)
      .then(response => {
        success(response.data.data.image_url)
      })
      .catch(error => {
        failure('Ooops! Something went wrong')
        console.error(error)
      })
  },
  content_css: '/css/tinymce_custom.css?cacheBuster=' + new Date().getTime(),
  image_dimensions: false,
  height: 500,
  menubar: true,
  menu: {
    format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | formats blockformats fontformats fontsizes align lineheight | forecolor backcolor | removeformat' },
    view: { title: 'View', items: 'code | visualblocks | preview fullscreen' }
  },
  browser_spellcheck: true,
  contextmenu: false,
  keep_styles: false,
  forced_root_block: '',
  force_p_newlines: true,
  force_br_newlines: false,
  plugins: [
    'advlist autolink lists link image charmap print preview anchor',
    'searchreplace visualblocks code fullscreen',
    'insertdatetime media table paste code help wordcount'
  ],
  fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
  toolbar: 'undo redo | formatselect | forecolor underline bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | image media table link | code | fullscreen help',
  // formats: {
  //   h1: { block: 'h1', styles: { 'margin-bottom': '22px' } },
  //   h2: { block: 'h2', styles: { 'margin-bottom': '22px' } },
  //   h3: { block: 'h3', styles: { 'margin-bottom': '22px' } },
  //   h4: { block: 'h4', styles: { 'margin-bottom': '22px' } },
  //   h5: { block: 'h5', styles: { 'margin-bottom': '22px' } },
  //   h6: { block: 'h6', styles: { 'margin-bottom': '22px' } },
  //   p: { block: 'p', styles: { 'margin-bottom': '0px' } }

  // },
  extended_valid_elements: 'script[language|type|src]',
  media_url_resolver: function (data, resolve/*, reject*/) {
    console.log(data.url.includes('youtu.be'));

    var vId = data.url.split("/").pop();

    if((data.url.includes('youtu.be') ||data.url.includes('youtube')) && vId) {
      var embedUrl = 'https://www.youtube.com/embed/' + vId;
      var embedHtml = '<iframe src="' + embedUrl + '" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen style="aspect-ratio: 16 / 9 !important"></iframe>';
      resolve({html: embedHtml});
    } else {
      resolve({html: ''});
    }
  }
}
